import "./PolymerMeltFiltration.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import PolymerHero from "./sections/PolymerHero";
import PolymerGuide from "./sections/PolymerGuide";
import RelatedArticles from "./sections/RelatedArticles";
import QuoteBanner from "./sections/QuoteBanner";
import Footer from "@/reusable_sections/Footer";
export default function PolymerMeltFiltrationPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="PolymerMeltFiltration" />
      <PolymerHero />
      <PolymerGuide />
      <RelatedArticles />
      <QuoteBanner />
      <Footer />
    </div>;
}